import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from '@mui/material';
import { TeleobjectPendingAction } from './Teleobjects.types';

interface TeleobjectInhibitionDialogProps {
    open: boolean;
    pendingAction: TeleobjectPendingAction | null;
    saving: boolean;
    onCancel: () => void;
    onConfirm: () => void;
}

export function TeleobjectInhibitionDialog({
    open,
    pendingAction,
    saving,
    onCancel,
    onConfirm,
}: TeleobjectInhibitionDialogProps) {
    const isActivation = pendingAction?.action === 'ACTIVATE';
    const actionLabel = isActivation ? 'habilitar' : 'inibir';
    const amount = pendingAction?.teleObjectIds.length ?? 0;

    return (
        <Dialog
            open={open}
            onClose={saving ? undefined : onCancel}
            aria-labelledby="teleobject-inhibition-dialog-title"
            aria-describedby="teleobject-inhibition-dialog-description"
            disableEscapeKeyDown={saving}
        >
            <DialogTitle id="teleobject-inhibition-dialog-title">
                Confirmar ação
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="teleobject-inhibition-dialog-description">
                    Você deseja {actionLabel} {amount}{' '}
                    {amount === 1 ? 'teleobjeto' : 'teleobjetos'}? A situação
                    será atualizada após a confirmação do servidor.
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onCancel} disabled={saving}>
                    Cancelar
                </Button>
                <Button
                    onClick={onConfirm}
                    disabled={saving || !pendingAction}
                    variant="contained"
                    autoFocus
                >
                    {saving ? 'Salvando...' : 'Confirmar'}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
